import { TypographyElement, Skeleton } from 'UI'
import { ProfileTypes } from 'constants/'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'

const useStyles = createUseStyles(style)

export default ({ Title, Subtitle, ProfileType, AlternativePricePromo, PricePromo, loading, IsFree, titleSpacing, subTitleSpacing, titleSectionMarginTop, IsNew }) => {
  const theme = useTheme()
  const { titleSection, promoTag, promoTagContainer, freeTagContainer, freeTag, newBadge } = useStyles({ titleSectionMarginTop })
  const courseTitle = `${Text.courseTitle} ${Title}`
  return (
    <div className={titleSection}>
      {
        !loading && (!ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber) && (AlternativePricePromo || PricePromo) && !IsFree
          ? (
            <div className={promoTagContainer}>
              <TypographyElement
                variant='caption'
                color={theme.neutral[400]}
                spacing='4px 6px'
                className={promoTag}
              >
                {Text.promoText}
              </TypographyElement>
            </div>
            )
          : null
      }
      {
        !loading && IsFree
          ? (
            <div className={freeTagContainer}>
              <TypographyElement
                variant='caption'
                color={theme.success[0]}
                spacing='4px 6px'
                className={freeTag}
              >
                {Text.freeText}
              </TypographyElement>
            </div>
            )
          : null
      }
      {
        !loading && IsNew && !IsFree
          ? (
            <div className={freeTagContainer}>
              <TypographyElement
                variant='caption'
                color={theme.error[0]}
                spacing='4px 6px'
                className={newBadge}
              >
                {Text.newText}
              </TypographyElement>
            </div>
            )
          : null
      }
      {
        loading
          ? (
            <>
              <Skeleton lines={2} width={['80%', '40%']} height={50} gap={12} margin='0 0 16px 0' />
              <Skeleton lines={1} width='100%' height={30} gap={12} margin='0 0 24px 0' />
            </>
            )
          : (
            <>
              <TypographyElement
                variant='heading1'
                spacing={titleSpacing || '0 0 16px 0'}
                Component='h1'
                dataTest='course-title'
              >
                {courseTitle}
              </TypographyElement>
              <TypographyElement
                variant='body1'
                spacing={subTitleSpacing || '0 0 24px 0'}
                Component='p'
              >
                {Subtitle}
              </TypographyElement>
            </>
            )
      }
    </div>
  )
}
